import React from "react";
import "./index.scss";
const Loading = () => {
  return (
    <div className="container">
      <div className="loader" />
    </div>
  );
};

export default Loading;
